
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    textStyles() {
      return `
        color: ${this.blok.textColorOverride};
        ${this.blok.styles}`
    },
  },
}
